import {
    BASIC_COMPOSITION_TYPE,
    FIXED_COMPOSITION_TYPE,
    ITEM_TYPE,
} from "@constants";
import { v4 as uuid } from "uuid";
import { snapshot } from "valtio";

import { syncStore } from "@components/Synchronization/store";

// ---- Type Definitions ----

interface CompositionItem {
    compositions?: Record<string, CompositionItem>;
    name?: string;
    designation?: string;
    quantity: number;
    price: number;
    reference: string;
    iuud: string;
    fidelity?: number;
    tva?: number;
    path?: { name: string }[];
    date: string;
    stepTitle?: string;
    // eslint-disable-next-line
    selectedOptions?: any;
    // eslint-disable-next-line
    selectedOptionsUuid?: any;
    subcategoryTitle?: string;
    categoryTitle?: string;
    categoryParent?: number;
    comment?: string;
    stepRank?: number;
    isSubProduct?: boolean;
    isOfferParent?: boolean;
    isOfferChild?: boolean;
    isPromo?: boolean;
    isReward?: boolean;
    unity?: string;
    type?: string;
    parent?: number;
}

interface LineDiscount {
    discountTaux: number;
}
// eslint-disable-next-line

export function fillMiddlwareOrder(
    compoundItem: Record<string, CompositionItem>,
    parent: string,
    orderInfo: OrderInfoType,
    discountRate: number,
    isOrderPromo: boolean,
    lineDiscount: LineDiscount,
    data: LineDataType[]
): void {
    const { machineIpAddress } = snapshot(syncStore);
    const compoundLines: LineDataType[] = [];

    Object.values(compoundItem).forEach((item) => {
        if (item?.compositions !== undefined) {
            if (item.name) {
                const localLineIuud = uuid();

                compoundLines.push({
                    lineUuid: localLineIuud,
                    orderUuid: orderInfo.orderUuid,
                    horodatage: item.date,
                    codeManager: orderInfo.codeManager,
                    nomManager: orderInfo.nomManager,
                    codeVendeur: orderInfo.codeVendeur,
                    nomVendeur: orderInfo.nomVendeur,
                    reference: item.reference,
                    itemUuid: item.iuud,
                    typeLigne: item.isOfferParent ? "Article" : "MENU",
                    designation: item.designation,
                    prix: item.price,
                    qte: item.quantity,
                    poids: 0,
                    unite: item.unity,
                    libFamille: item.categoryTitle,
                    libSousFamille: item.subcategoryTitle,
                    numFamille: item.parent,
                    numSousFamille: 0,
                    libelleTVA: "",
                    numTVA: 0,
                    tauxTVA: item.tva ?? 0,
                    ipOrigine: machineIpAddress,
                    orderOrigine: "",
                    lineDiscount,
                    montantTotalTTC:
                        item.price * item.quantity -
                        item.price *
                            item.quantity *
                            (lineDiscount.discountTaux / 100),
                    montantTotalHT: 0,
                    tag: "",
                    pointFid: item.fidelity,
                    ModifierUuid: "",
                    parentLineUuid: item.isOfferChild ? "" : parent,
                    stepTitle: item.stepTitle,
                    stepRank: item.stepRank,
                    comment: item.comment ?? "",
                    isSubProduct: item.isSubProduct,
                    isOfferParent: item.isOfferParent,
                    isOfferChild: item.isOfferChild,
                    discountRate: getDiscountRateValue(
                        item,
                        discountRate,
                        isOrderPromo
                    ),
                    isPromo: item.isPromo ?? false,
                });

                parent = localLineIuud;
            }
            // eslint-disable-next-line
            Object.entries(item.compositions).forEach(([_, composition]) => {
                if (composition.compositions === undefined) {
                    const localLineIuud = uuid();

                    compoundLines.push({
                        lineUuid: localLineIuud,
                        orderUuid: orderInfo.orderUuid,
                        horodatage: composition.date,
                        codeManager: orderInfo.codeManager,
                        nomManager: orderInfo.nomManager,
                        codeVendeur: orderInfo.codeVendeur,
                        nomVendeur: orderInfo.nomVendeur,
                        reference: composition.reference,
                        itemUuid: composition.iuud,
                        typeLigne:
                            composition.type === ITEM_TYPE
                                ? "Article"
                                : composition.type === FIXED_COMPOSITION_TYPE
                                ? FIXED_COMPOSITION_TYPE
                                : item.type,
                        designation: composition.designation,
                        prix:
                            composition.path?.[composition.path.length - 3]
                                ?.name === BASIC_COMPOSITION_TYPE
                                ? 0
                                : composition.price,
                        qte: composition.quantity,
                        poids: 0,
                        unite: composition.unity,
                        libFamille: composition.categoryTitle,
                        libSousFamille: composition.subcategoryTitle,
                        numFamille: composition.categoryParent,
                        numSousFamille: 0,
                        libelleTVA: "",
                        numTVA: 0,
                        tauxTVA: composition.tva ?? 0,
                        ipOrigine: machineIpAddress,
                        orderOrigine: "",
                        lineDiscount,
                        montantTotalTTC:
                            composition.price * composition.quantity -
                            composition.price *
                                composition.quantity *
                                (lineDiscount.discountTaux / 100),
                        montantTotalHT: 0,
                        tag: "",
                        pointFid: composition.fidelity,
                        ModifierUuid: "",
                        parentLineUuid: composition.isOfferChild ? "" : parent,
                        stepTitle: composition.stepTitle,
                        selectedOptions: composition.selectedOptions,
                        selectedOptionsUuid: composition.selectedOptionsUuid,
                        stepRank: composition.stepRank,
                        comment: composition.comment,
                        isSubProduct: composition.isSubProduct,
                        isOfferParent: composition.isOfferParent,
                        isOfferChild: composition.isOfferChild,
                        discountRate: getDiscountRateValue(
                            item,
                            discountRate,
                            isOrderPromo
                        ),
                        isPromo: composition.isPromo,
                    });
                } else {
                    let localParent = parent;
                    if (composition.name) {
                        const localLineIuud = uuid();

                        compoundLines.push({
                            lineUuid: localLineIuud,
                            orderUuid: orderInfo.orderUuid,
                            horodatage: composition.date,
                            codeManager: orderInfo.codeManager,
                            nomManager: orderInfo.nomManager,
                            codeVendeur: orderInfo.codeVendeur,
                            nomVendeur: orderInfo.nomVendeur,
                            reference: composition.reference,
                            itemUuid: composition.iuud,
                            typeLigne: composition.isOfferParent
                                ? "Article"
                                : "MENU",
                            designation: composition.designation,
                            prix: composition.price,
                            qte: composition.quantity,
                            poids: 0,
                            unite: composition.unity,
                            libFamille: composition.categoryTitle,
                            libSousFamille: composition.subcategoryTitle,
                            numFamille: composition.categoryParent,
                            numSousFamille: 0,
                            libelleTVA: "",
                            numTVA: 0,
                            tauxTVA: composition.tva ?? 0,
                            ipOrigine: machineIpAddress,
                            orderOrigine: "",
                            lineDiscount,
                            montantTotalTTC:
                                composition.price * composition.quantity -
                                composition.price *
                                    composition.quantity *
                                    (lineDiscount.discountTaux / 100),
                            montantTotalHT: 0,
                            tag: "",
                            pointFid: composition.fidelity,
                            ModifierUuid: "",
                            parentLineUuid: composition.isOfferChild
                                ? ""
                                : parent,
                            stepTitle: composition.stepTitle,
                            selectedOptions: composition.selectedOptions,
                            selectedOptionsUuid:
                                composition.selectedOptionsUuid,
                            stepRank: composition.stepRank,
                            comment: composition.comment,
                            isSubProduct: composition.isSubProduct,
                            isOfferParent: composition.isOfferParent,
                            isOfferChild: composition.isOfferChild,
                            discountRate: getDiscountRateValue(
                                item,
                                discountRate,
                                isOrderPromo
                            ),
                            isPromo: composition.isPromo,
                        });

                        localParent = localLineIuud;
                    }

                    fillMiddlwareOrder(
                        composition.compositions,
                        localParent,
                        orderInfo,
                        discountRate,
                        isOrderPromo,
                        lineDiscount,
                        data
                    );
                }
            });
        } else {
            const localLineIuud = uuid();

            compoundLines.push({
                lineUuid: localLineIuud,
                orderUuid: orderInfo.orderUuid,
                horodatage: item.date,
                codeManager: orderInfo.codeManager,
                nomManager: orderInfo.nomManager,
                codeVendeur: orderInfo.codeVendeur,
                nomVendeur: orderInfo.nomVendeur,
                reference: item.reference,
                itemUuid: item.iuud,
                typeLigne:
                    item.path?.[item.path.length - 3]?.name ===
                    BASIC_COMPOSITION_TYPE
                        ? "COMPOSANT DE BASE"
                        : "Article",
                designation: item.designation,
                prix:
                    item.path?.[item.path.length - 3]?.name ===
                    BASIC_COMPOSITION_TYPE
                        ? 0
                        : item.price,
                qte: item.quantity,
                poids: 0,
                unite: item.unity,
                libFamille: item.categoryTitle,
                libSousFamille: item.subcategoryTitle,
                numFamille: item.parent,
                numSousFamille: 0,
                libelleTVA: "",
                numTVA: 0,
                tauxTVA: item.tva ?? 0,
                ipOrigine: machineIpAddress,
                orderOrigine: "",
                lineDiscount,
                montantTotalTTC:
                    item.price * item.quantity -
                    item.price *
                        item.quantity *
                        (lineDiscount.discountTaux / 100),
                montantTotalHT: 0,
                tag: "",
                pointFid: item.fidelity,
                ModifierUuid: "",
                parentLineUuid: item.isOfferChild ? "" : parent,
                comment: item.comment ?? "",
                isSubProduct: item.isSubProduct,
                isOfferParent: item.isOfferParent,
                isOfferChild: item.isOfferChild,
                stepTitle: item.stepTitle,
                discountRate: getDiscountRateValue(
                    item,
                    discountRate,
                    isOrderPromo
                ),
                isPromo: item.isPromo ?? false,
            });
        }
    });

    data?.push(...compoundLines);
}

export function getDiscountRateValue(
    item: CompositionItem,
    discountRate: number,
    isOrderPromo: boolean
): number {
    if (item.isReward) {
        return 100;
    }

    if (item.isPromo || isOrderPromo) {
        return discountRate;
    }

    return 0;
}
